/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-consumable-return-bill-item.reducer';

export const PharmacyConsumableReturnBillItem = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacyConsumableReturnBillItemList = useAppSelector(state => state.pharmacyConsumableReturnBillItem.entities);
  const loading = useAppSelector(state => state.pharmacyConsumableReturnBillItem.loading);
  const totalItems = useAppSelector(state => state.pharmacyConsumableReturnBillItem.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-consumable-return-bill-item-heading" data-cy="PharmacyConsumableReturnBillItemHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.home.title">
          Pharmacy Consumable Return Bill Items
        </Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/pharmacy-consumable-return-bill-item/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.home.createLabel">
              Create new Pharmacy Consumable Return Bill Item
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacyConsumableReturnBillItem.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacyConsumableReturnBillItemList && pharmacyConsumableReturnBillItemList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('chargedMrp')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.chargedMrp">Charged Mrp</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chargedMrp')} />
                </th>
                <th className="hand" onClick={sort('returnClaimed')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.returnClaimed">Return Claimed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('returnClaimed')} />
                </th>
                <th className="hand" onClick={sort('returnQty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.returnQty">Return Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('returnQty')} />
                </th>
                <th className="hand" onClick={sort('manufacDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.manufacDate">Manufac Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('manufacDate')} />
                </th>
                <th className="hand" onClick={sort('expDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.expDate">Exp Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expDate')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.pharmacyStock">Pharmacy Stock</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.returnBill">Return Bill</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacyConsumableReturnBillItemList.map((pharmacyConsumableReturnBillItem, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button
                      tag={Link}
                      to={`/pharmacy-consumable-return-bill-item/${pharmacyConsumableReturnBillItem.id}`}
                      color="link"
                      size="sm"
                    >
                      {pharmacyConsumableReturnBillItem.id}
                    </Button>
                  </td>
                  <td>{pharmacyConsumableReturnBillItem.chargedMrp}</td>
                  <td>{pharmacyConsumableReturnBillItem.returnClaimed}</td>
                  <td>{pharmacyConsumableReturnBillItem.returnQty}</td>
                  <td>{pharmacyConsumableReturnBillItem.manufacDate}</td>
                  <td>{pharmacyConsumableReturnBillItem.expDate}</td>
                  <td>{pharmacyConsumableReturnBillItem.active ? 'true' : 'false'}</td>
                  <td>{pharmacyConsumableReturnBillItem.cursor}</td>
                  <td>{pharmacyConsumableReturnBillItem.timestampEntry}</td>
                  <td>{pharmacyConsumableReturnBillItem.microSec}</td>
                  <td>{pharmacyConsumableReturnBillItem.lastUpdated}</td>
                  <td>
                    {pharmacyConsumableReturnBillItem.pharmacyStock ? (
                      <Link to={`/pharmacy-consumable-stock/${pharmacyConsumableReturnBillItem.pharmacyStock.id}`}>
                        {pharmacyConsumableReturnBillItem.pharmacyStock.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyConsumableReturnBillItem.returnBill ? (
                      <Link to={`/pharmacy-return-bill/${pharmacyConsumableReturnBillItem.returnBill.id}`}>
                        {pharmacyConsumableReturnBillItem.returnBill.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pharmacy-consumable-return-bill-item/${pharmacyConsumableReturnBillItem.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-consumable-return-bill-item/${pharmacyConsumableReturnBillItem.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-consumable-return-bill-item/${pharmacyConsumableReturnBillItem.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableReturnBillItem.home.notFound">
                No Pharmacy Consumable Return Bill Items found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacyConsumableReturnBillItemList && pharmacyConsumableReturnBillItemList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacyConsumableReturnBillItem;
